import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/free-brands-svg-icons';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    title: string;
    icon: IconProp | IconDefinition | string;
    variant: string;
    acessible?: boolean;
}
const Button: FC<ButtonProps> = ({
    title,
    icon,
    variant = 'primary',
    acessible = false,
    ...attributes
}) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            className={`btn-generic--${variant} ${acessible ? 'acessible' : ''}`}
            {...attributes}
        >
            <FontAwesomeIcon className="mr-2" icon={icon as IconProp} />
            {t(title)}
        </button>
    );
};

export default Button;
